import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import Select from "react-select";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import Style from "../../CustomOffers/CreateOffer/createOffer.module.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import useAddOfficeDelivery from "./useAddOfficeDelivery";

const AddOfficeDelivery = ({ isStickyFooter, handleCreateClick, refetch }) => {
  const {
    formik,
    isEdit,
    basicData,
    isLoading,
    handleTypeChange,
    getFieldError,
    closeModal,
  } = useAddOfficeDelivery(handleCreateClick, refetch);

  return (
    <div className="row">
      <div className="input-wrap pro-mb-4">
        <Input
          label={"Office Name"}
          type="text"
          id="office_name"
          name="office_name"
          className={`pro-input lg ${getFieldError("office_name") && " error"}`}
          {...formik.getFieldProps("office_name")}
          error={getFieldError("office_name")}
          errorMessage={getFieldError("office_name")}
        />
        <div className="pro-rtl">
          <Input
            label={"(عنوان)Office Name"}
            type="text"
            id="alias_office_name"
            name="alias_office_name"
            className={`pro-input lg ${
              getFieldError("alias_office_name") && " error"
            }`}
            {...formik.getFieldProps("alias_office_name")}
            error={getFieldError("alias_office_name")}
            errorMessage={getFieldError("alias_office_name")}
          />
        </div>
        <Input
          label={"Office Address"}
          type="text"
          id="office_address"
          name="office_address"
          className={`pro-input lg ${
            getFieldError("office_address") && " error"
          }`}
          {...formik.getFieldProps("office_address")}
          error={getFieldError("office_address")}
          errorMessage={getFieldError("office_address")}
        />
        <div className="pro-rtl">
          <Input
            label={"(عنوان المكتب) Office Address"}
            type="text"
            id="alias_office_address"
            name="alias_office_address"
            className={`pro-input lg ${getFieldError("alias_office_address") && " error"}`}
            {...formik.getFieldProps("alias_office_address")}
            error={getFieldError("alias_office_address")}
            errorMessage={getFieldError("alias_office_address")}
          />
        </div>
        <div className="input-wrap pro-mb-4">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Store
          </label>
          <Select
            id="stores"
            name="stores"
            placeholder={"Select"}
            className={`pro-input lg  ${getFieldError("stores") && " error"}`}
            classNamePrefix="pro-input"
            options={basicData?.data?.stores ?? []}
            value={
              basicData?.data?.stores?.filter((item) =>
                formik?.values?.stores?.includes(item)
              ) || []
            }
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?._id}
            onBlur={formik.handleBlur("stores")}
            onChange={(e) => handleTypeChange(e)}
            menuPlacement="auto"
            isMulti={true}
          />
          {getFieldError("stores") && (
            <span className="error-text">{getFieldError("stores")}</span>
          )}
        </div>
     
        <div className="pro-check-box pro-py-2">
          <div className="form-check form-switch ">
            <input
              className="form-check-input cursor-pointer"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={Boolean(formik.values?.status === 1) ?? false}
              onChange={(e) =>
                formik.setFieldValue(`status`, e?.target?.checked ? 1 : 2)
              }
            />
            <label htmlFor="default" className="pro-check-label">
              Status
            </label>
          </div>
        </div>
        <div
          className={`col-12 pro-d-flex pro-justify-end ${
            isStickyFooter && "offcanvas-footer-sticky-btns"
          }`}
        >
          <Button
            className={"pro-btn-link lg pro-px-5"}
            onClick={() => closeModal()}
          >
            Cancel
          </Button>

          <Button
            className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
            type="submit"
            disabled={isLoading}
            onClick={formik.handleSubmit}
          >
            {!isEdit
              ? isLoading
                ? "Creating..."
                : "Create"
              : isLoading
              ? "Updating..."
              : "Update"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AddOfficeDelivery;
